import { PlanPrivilege } from "../TabPrices/componentes/PlanPrivilege/PlanPrivilege";
import "./Tarifas.scss";
import { useNavigate } from "react-router-dom";

export const Tarifas = () => {
  const navigate = useNavigate();

  const handleRedirectClick = () => {
    navigate("/prices?sectionId=tableRef");
  };

  return (
    <div className="tarifas">
      <div className="sectionContainer">
        <p className="sectionTitle"> Tarifa y planes</p>
        <h2 className="sectionDefinition"> Tenemos el plan perfecto</h2>
        <p className="sectionDetail">
          La suite de herramientas de pago "cardless" más completa
        </p>
      </div>

      <PlanPrivilege handleClick={handleRedirectClick} />
    </div>
  );
};
